import React, { useState } from 'react'
import styled from 'styled-components'
import Icon from '@/components/common/Icon'
import classNames from 'classnames'

const AccordionSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const AccordionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  background: #f9f9f9;
  border-radius: 16px;
  transition: background 0.3s ease-in-out;
  color: #3f3f49;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.225px;

  &:hover {
    background: #e9e9e9;
  }
`

const AccordionContent = styled.ul`
  display: none;
  list-style-type: none;
  margin: 0;
  padding: 15px 20px;
  color: #6e7278;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.225px;

  &.open {
    display: block;
  }
`

const DropdownIcon = styled(Icon)`
  transition: transform 0.3s ease;

  &.open {
    transform: rotate(180deg);
  }
`

const Accordion = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(null)

  const handleToggle = (index) => {
    setOpenIndex(index === openIndex ? null : index)
  }

  return items.map((item, index) => (
    <AccordionItemComponent
      key={index}
      title={item.title}
      links={item.links}
      isOpen={openIndex === index}
      onToggle={() => handleToggle(index)}
    />
  ))
}

const AccordionItemComponent = ({ title, links, isOpen, onToggle }) => {
  const accordionClass = classNames({
    open: isOpen,
  })

  return (
    <AccordionSection>
      <AccordionTitle className={accordionClass} onClick={onToggle}>
        <span>{title}</span>
        <DropdownIcon
          className={`ml-auto ${accordionClass}`}
          icon="dropdown-icon"
          color="black"
        />
      </AccordionTitle>
      <AccordionContent className={accordionClass}>{links}</AccordionContent>
    </AccordionSection>
  )
}

export default Accordion
